import { forwardRef } from 'react';
import BaseButton from './base/BaseButton';
import Tooltip from './DeferredTooltip';

const ModuleHeaderActionButton = forwardRef(function ModuleHeaderActionButton({
  label,
  tooltip = label,
  icon,
  active = false,
  disabled = false,
  className = '',
  onClick,
  type = 'button',
  ...buttonProps
}, ref) {
  const ownsDisclosure = Object.prototype.hasOwnProperty.call(buttonProps, 'aria-expanded');

  const handleHeaderEvent = (event) => {
    event.stopPropagation();
  };

  const handleClick = (event) => {
    event.stopPropagation();
    onClick?.(event);
  };

  const button = (
    <BaseButton
      ref={ref}
      type={type}
      disabled={disabled}
      aria-label={label}
      aria-pressed={active && !ownsDisclosure ? true : undefined}
      {...buttonProps}
      className={[
        'module-header-action-button',
        active && 'is-active',
        className,
      ].filter(Boolean).join(' ')}
      data-module-no-toggle="true"
      data-module-no-drag="true"
      onClick={handleClick}
      onMouseDown={handleHeaderEvent}
      onPointerDown={handleHeaderEvent}
      onTouchStart={handleHeaderEvent}
    >
      {icon}
    </BaseButton>
  );

  if (!tooltip) {
    return button;
  }

  return (
    <Tooltip
      text={tooltip}
      delay={300}
      triggerClassName="module-header-action-button__trigger"
    >
      {button}
    </Tooltip>
  );
});

export default ModuleHeaderActionButton;
